import React from 'react';
import { Shield } from 'lucide-react';

export const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors px-4 py-8">
      <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <Shield className="w-16 h-16 text-blue-600 dark:text-blue-400 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Privacy Policy
          </h1>
        </div>
        
        <div className="prose prose-gray dark:prose-invert max-w-none text-gray-900 dark:text-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Calorie Cat Privacy Policy</h2>
          
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
            <strong>Effective Date: July 22, 2025</strong>
          </p>
          
          <p className="mb-6">
            Your privacy matters to us. This Privacy Policy explains how Calorie Cat collects, uses, and protects your information.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">What We Collect</h3>
          <ul className="mb-6 list-disc pl-6">
            <li className="mb-2">
              <strong>Personal Information:</strong> Calorie Cat does <strong>not</strong> require you to create an account or share personal details such as your name or email to use core features. But will require your age, weight, and activity levels in order to determine calorie goals.
            </li>
            <li className="mb-2">
              <strong>Health & Usage Data:</strong> Calorie Cat records meal logs, calories, macronutrients, and app usage statistics; all stored <strong>locally</strong> on your device, unless you explicitly opt in to backup or sync features.
            </li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">How We Use Data</h3>
          <ul className="mb-6 list-disc pl-6">
            <li>To power app features: logging meals, analyzing your progress, and tracking daily/weekly/monthly goals.</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Data Sharing</h3>
          <ul className="mb-6 list-disc pl-6">
            <li className="mb-2">
              <strong>We do not sell or share your data</strong> with third parties for advertising or marketing.
            </li>
            <li>Data is only transmitted if you enable syncing or backups (e.g., iCloud), or if required by law.</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Your Choices</h3>
          <ul className="mb-6 list-disc pl-6">
            <li className="mb-2">You control all your nutrition data in Calorie Cat.</li>
            <li>If you uninstall the app, all your data is erased unless backed up to a cloud service you control.</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Changes to This Policy</h3>
          <p className="mb-6">
            We may update this policy from time to time. You'll be notified of major changes in the app.
          </p>

          <hr className="my-8 border-gray-200 dark:border-gray-600" />
          
          <p className="text-center italic text-gray-600 dark:text-gray-400">
            Your health, your data, your cute calorie tracker. Thank you for using Calorie Cat!
          </p>
        </div>
      </div>
    </div>
  );
};